(() => {
  const initializeToolbar = (toolbar) => {
    if (!toolbar || toolbar.dataset.initialized === 'true') return;
    toolbar.dataset.initialized = 'true';

    const backButton = toolbar.querySelector('[data-bh-gallery-back]');
    const shareButton = toolbar.querySelector('[data-bh-gallery-share]');

    backButton?.addEventListener('click', () => {
      if (window.history.length > 1) {
        window.history.back();
        return;
      }

      window.location.assign(toolbar.dataset.homeUrl || '/');
    });

    shareButton?.addEventListener('click', async () => {
      const shareData = {
        title: toolbar.dataset.shareTitle || document.title,
        url: toolbar.dataset.shareUrl || window.location.href
      };

      try {
        if (navigator.share) {
          await navigator.share(shareData);
          return;
        }

        await navigator.clipboard.writeText(shareData.url);
        shareButton.classList.add('is-copied');
        shareButton.setAttribute('aria-label', 'Enlace copiado');
        window.setTimeout(() => {
          shareButton.classList.remove('is-copied');
          shareButton.setAttribute('aria-label', 'Compartir producto');
        }, 1600);
      } catch (error) {
        if (error?.name !== 'AbortError') {
          window.location.href = `mailto:?subject=${encodeURIComponent(shareData.title)}&body=${encodeURIComponent(shareData.url)}`;
        }
      }
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-bh-product-gallery-toolbar]').forEach(initializeToolbar);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
